import {
  IonButton,
  IonCol,
  IonInput,
  IonRouterLink,
  IonRow,
  IonSpinner,
} from '@ionic/react';
import classNames from 'classnames';
import * as Yup from 'yup';
import { Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import Form from '../../components/common/Form';
import { uppercaseFirstLetter } from '../../util/string';
import useQueryParams from '../../hooks/useQueryParams';
import { useFirebase } from '../../services/firebase';
import { resetPassword } from '../../api/cloudFunctions';
import { getFunctions } from 'firebase/functions';

interface ForgotPasswordFormProps {
  onSuccess: () => void;
  onError: () => void;
}
const ButtonRow = styled(IonRow)`
  margin-top: 8px;
`;
const HiddenSubmitButton = styled.button`
  position: absolute;
  display: none;
`;
const CenteredRow = styled(IonRow)`
  justify-content: center;
`;
const Link = styled(IonRouterLink)`
  margin: 16px 0;
`;

const URL = process.env.REACT_APP_URL || window.location.origin;

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  onSuccess,
  onError,
}) => {
  const { app } = useFirebase();
  const searchParams = useQueryParams();
  return (
    <Formik
      validateOnMount
      initialValues={{
        email: searchParams.get('email') || '',
      }}
      onSubmit={async (values, helpers) => {
        try {
          const fns = getFunctions(app);
          await resetPassword(fns, values.email);

          onSuccess();
          helpers.resetForm();
          helpers.setFieldTouched('email', false, false);
        } catch (e) {
          console.error(e);
          onError();
        }
      }}
      validationSchema={Yup.object({
        email: Yup.string().email().required(),
      })}
    >
      {({
        values,
        touched,
        errors,
        setFieldTouched,
        setFieldValue,
        isValid,
        isSubmitting,
      }) => (
        <Form>
          <IonInput
            className={classNames({
              ['ion-invalid']: errors.email,
              ['ion-touched']: touched.email,
            })}
            label="Email"
            labelPlacement="floating"
            type="text"
            name="email"
            required
            autofocus
            value={values.email}
            onIonInput={(e) => {
              setFieldValue('email', e.detail.value);
              setFieldTouched('email', true);
            }}
            errorText={uppercaseFirstLetter(errors.email as string)}
          />

          <ButtonRow>
            <IonCol>
              <IonButton
                type="submit"
                disabled={!isValid || isSubmitting}
                expand="block"
              >
                {isSubmitting ? (
                  <>
                    <IonSpinner
                      name="crescent"
                      style={{ marginRight: '8px' }}
                    />
                    Loading
                  </>
                ) : (
                  'Send Password Reset Email'
                )}
              </IonButton>
              {/* Need this for Ionic hack... so the form submits on enter */}
              <HiddenSubmitButton type="submit" />
            </IonCol>
          </ButtonRow>

          <CenteredRow>
            <Link routerLink="/login">Login</Link>
          </CenteredRow>
        </Form>
      )}
    </Formik>
  );
};

export default ForgotPasswordForm;
